import React from "react";

import Panel, { PanelProps } from "..";
import Button from "../../Button";
import CloseButton from "../../Button/templates/CloseButton";
import Typography from "../../Text";
import css from "./FilterPanel.module.scss";

export interface FilterPanelProps extends PanelProps {
	title?: string;
	subtitle?: string;
	onSaveFilters?: () => void;
	children?: React.ReactNode;
	onClose: () => void;
}

/**
 *
 * @deprecated Use the PanelFilter component from the py-components package instead
 */
const FilterPanel = ({
	isOpen,
	onClose,
	title = "Apply Filters",
	subtitle,
	onSaveFilters,
	children,
}: FilterPanelProps) => {
	return (
		<Panel side="left" isOpen={isOpen} onClose={onClose}>
			<div className={css.filtersContainer}>
				<div className={css.filters}>
					<div>
						<div className={css.headerRow}>
							<Typography weight="semi-bold" size="sub-heading" color="neutral-10">
								{title}
							</Typography>
							<CloseButton testId="closeButton" onClick={onClose} />
						</div>
						{subtitle && (
							<div className={css.subtitleRow}>
								<Typography weight="regular" size="paragraph-3" color="neutral-7">
									{subtitle}
								</Typography>
							</div>
						)}
						{children}
					</div>
				</div>
				{onSaveFilters && (
					<div className={css.applyFiltersButtonContainer}>
						<Button size="large" className={css.applyButton} onClick={onSaveFilters}>
							Apply Filters
						</Button>
					</div>
				)}
			</div>
		</Panel>
	);
};

export default FilterPanel;
